import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataForCustomFormModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { RegexToCheckEMail } from '@bo-client/shared/forms/forms.validators';
import { uri } from '@bo-client/shared/constants/uri';
import { GridRegistrationStatusEnum } from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { CustomFormComponent } from '@bo-client/activation-management/custom-form.component';
import { SelectableStatus } from '@bo-client/shared/status/status.model';
import { StatusService } from '@bo-client/shared/status/status.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-gr-change-state',
  templateUrl: './gr-change-state.component.html',
  styleUrls: ['./gr-change-state.component.scss']
})
export class GrChangeStateComponent
  implements
    CustomFormComponent<
      GridRegistrationModel,
      {
        additionalData: string;
        comment: string;
      }
    >,
    OnInit
{
  @Input() data: DataForCustomFormModel<GridRegistrationModel>;
  @Output() onConfirm: EventEmitter<{
    additionalData: string;
    comment: string;
  }> = new EventEmitter();

  public model: GridRegistrationModel;
  public currentForm: FormGroup;
  public comment = '';
  public statusOptions$: Observable<SelectableStatus[]>;

  constructor(private fb: FormBuilder, private statusService: StatusService) {}

  ngOnInit(): void {
    this.model = this.data.model;
    this.statusOptions$ = this.statusService.selectableWithCurrent$(
      'gridRegistration',
      this.data.model.state
    );
    this.currentForm = this.fb.group({
      newState: [this.data.model.state, [Validators.required]],
      comment: [null, [Validators.required, Validators.maxLength(255)]]
    });
  }

  cancel() {
    this.onConfirm.emit(null);
  }

  confirm() {
    this.onConfirm.emit({
      additionalData: this.currentForm.get('newState').value,
      comment: this.currentForm.get('comment').value
    });
  }
}
